<template>
    <div class="body d-flex py-lg-3 py-md-2">
        <div class="container-xxl">
            <div class="row g-3">
                <!-- Left Column with Tabs -->
                <div class="col-xl-8 col-lg-7 col-md-12 rightborderSec">
                    <!-- Project hero (redesign) -->
                    <div class="wx-hero" v-if="projectViewData">
                        <div class="wx-hero-row">
                            <div class="wx-hero-logo">{{ initials(projectViewData.client?.nickname) }}</div>
                            <div class="wx-hero-main">
                                <div class="wx-hero-crumb">
                                    <router-link to="/projects">Projects</router-link> /
                                    <router-link v-if="superUser || canViewAllClients"
                                        :to="{ path: 'client', query: { id: projectViewData.client?.id } }">{{ projectViewData.client?.nickname }}</router-link>
                                    <span v-else>{{ projectViewData.client?.nickname }}</span>
                                </div>
                                <h1 class="wx-hero-title" v-html="projectViewData.info?.description"></h1>
                                <div class="wx-hero-meta">
                            <div class="status-dropdown wx-hero-status">
                                <button class="status-button justify-content-center" v-if="projectViewData"
                                    :style="getStatusStyle(projectViewData.status?.id)">
                                    <i :class="getStatusIcon(projectViewData.status?.id)"
                                        v-if="canEditProject(projectViewData) || canEditAllProjects || superUser"></i>
                                    {{ getCurrentStatus(projectViewData.status?.id) }}
                                    <i class="fa fa-caret-down"
                                        v-if="canEditProject(projectViewData) || canEditAllProjects || superUser"></i>
                                </button>

                                <!-- Dropdown Content (Visible on Hover) -->
                                <div class="status-dropdown-content"
                                    v-if="canEditProject(projectViewData) || canEditAllProjects || superUser">
                                    <button v-if="projectViewData" v-for="status in statuses" :key="status.id"
                                        @click="selectStatus(projectViewData.info?.id, status.id)"
                                        :style="getStatusStyle(status.id)"
                                        :class="{ 'active-status': projectViewData.status?.id === status.id }">
                                        <i :class="status.icon"></i>
                                        {{ status.description }}
                                    </button>
                                </div>
                            </div>
                                    <span class="wx-chip">{{ projectViewData.info?.code }}</span>
                                    <span class="wx-chip" v-if="projectViewData.service">{{ projectViewData.service.title }}</span>
                                    <span class="wx-chip">{{ projectViewData.info?.startDate }} → {{ projectViewData.info?.endDate }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="wx-hero-stats">
                            <div class="wx-hs" v-if="projectViewData.manager"><div class="l">Manager</div><div class="v">{{ projectViewData.manager.username }}</div></div>
                            <div class="wx-hs" v-if="daysLeft(projectViewData.info?.endDate) !== null">
                                <div class="l">{{ daysLeft(projectViewData.info?.endDate) >= 0 ? 'Μέρες ως το τέλος' : 'Εκπρόθεσμο (μέρες)' }}</div>
                                <div class="v">{{ Math.abs(daysLeft(projectViewData.info?.endDate)) }}</div>
                            </div>
                            <div class="wx-hs" v-if="projectViewData.unread_comments"><div class="l">Νέα σχόλια</div><div class="v">{{ projectViewData.unread_comments }}</div></div>
                            <div class="wx-hero-team">
                                <template v-for="user in projectViewData.assigned" :key="user.id">
                                    <img v-if="user?.avatar_file_name" :src="`/storage/avatars/${user.avatar_file_name}`" :title="user.username" class="wx-av" />
                                    <span v-else class="wx-av" :title="user.username">{{ initials(user.username) }}</span>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="wx-tabrow">
                    <!-- Tabs -->
                    <ul class="nav nav-tabs mb-3 p-0 gap-xl-3 gap-2 fs-6 justifyContentbetmob" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'info' }"
                                @click.prevent="setActiveTab('info')" href="#">Info</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'managerBrief' }"
                                @click.prevent="setActiveTab('managerBrief')" href="#">Manager's Brief</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'tasks' }"
                                @click.prevent="setActiveTab('tasks')" href="#">Tasks</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'projectChat' }"
                                @click.prevent="setActiveTab('projectChat')" href="#">Project Chat</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'files' }"
                                @click.prevent="setActiveTab('files')" href="#">Files</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'report' }"
                                @click.prevent="setActiveTab('report')" href="#">Report</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{ active: activeTab === 'search' }"
                                @click.prevent="setActiveTab('search')" href="#">Search</a>
                        </li>
                    </ul>
                    <div class="wx-tab-actions">
                        <!-- Button Positioned Over Border -->
                        <div class="status-button-wrapper">
                            <button class="btn btn-dark btn-sm p-1"
                                v-if="!isEditingInfo && activeTab === 'info' && (superUser || canEditAllProjects || canEditProject(projectViewData))"
                                @click="editProject">
                                <i class="wx-ic wx-ic-edit" title="Edit"></i>
                            </button>
                            <div v-if="isEditingInfo && activeTab === 'info'" class="editing-actions">
                                <!-- Save Button -->
                                <button class="btn btn-secondary p-1" @click="saveInfo">
                                    <i class="wx-ic wx-ic-check" title="Save"></i>
                                </button>

                                <!-- Cancel Button -->
                                <button class="btn btn-danger p-1 mt-xl-2 mt-0" @click="cancelEditing">
                                    <!-- <i class="icofont-close text-white" style="font-size: 2em"></i> -->
                                    <i class="wx-ic wx-ic-x" title="Cancel"></i>
                                </button>
                            </div>
                            <!-- Edit Button Manager-->
                            <button class="btn btn-dark btn-sm p-1"
                                v-if="!isEditingManagersBrief && activeTab === 'managerBrief' && (projectViewData.info.managerId == currentUserInfo?.id || superUser || canEditAllProjects)"
                                @click="editProjectManager">
                                <i class="wx-ic wx-ic-edit" title="Edit"></i>
                            </button>

                            <!-- Save and Cancel Buttons -->
                            <div v-if="isEditingManagersBrief && activeTab === 'managerBrief' && (projectViewData.info.managerId == currentUserInfo?.id || superUser || canEditAllProjects)"
                                class="editing-actions">
                                <!-- Save Button -->
                                <button class="btn btn-secondary mb-xl-3 mb-0 p-1" @click="saveManager">
                                    <i class="wx-ic wx-ic-check" title="Save"></i>
                                </button>

                                <!-- Cancel Button -->
                                <button class="btn btn-danger mt-2 p-1  " @click="cancelEditingManager">
                                    <!-- <i class="icofont-close text-white" style="font-size: 2em"></i> -->
                                    <i class="wx-ic wx-ic-x" title="Cancel"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    </div>

                    

                    <!-- Tab Content -->
                    <div class="tab-content pb-5">
                        <!-- Info Tab -->
                        <div v-if="activeTab === 'info'" class="tab-pane fade show active">

                            <div class="card">
                                <div class="card-body p-0" v-if="!isEditingInfo">
                                    <div v-html="projectViewData.info?.body" v-if="projectViewData" v-target-blank>
                                    </div>
                                </div>
                                <div class="card-body p-0" v-if="isEditingInfo">
                                    <div class="mb-3" v-if="projectViewData">
                                        <Editor api-key="no-api-key" :init="tinymceInit"
                                            v-model="projectViewData.info.body"></Editor>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="activeTab === 'report'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body">
                                    <div
                                        class="card-header py-1 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between flex-wrap">

                                        <div class="d-flex w-100 justify-content-start align-items-center gap-2">
                                            <!-- Date From Input -->
                                            <div class="d-flex text-nowrap align-items-center gap-1">
                                                <label for="filterDateFrom" class="form-label mb-0">Ημ/νία από:</label>
                                                <input type="date" class="form-control"
                                                    v-model="filtersReport.dateFrom">
                                            </div>

                                            <!-- Date To Input -->
                                            <div class="d-flex text-nowrap align-items-center gap-1">
                                                <label for="filterDateTo" class="form-label mb-0">Ημ/νία έως:</label>
                                                <input type="date" class="form-control" v-model="filtersReport.dateTo">
                                            </div>

                                            <!-- Search Button -->
                                            <div class="col-auto">
                                                <button type="button" class="btn btn-secondary"
                                                    @click="() => { fetchReportData(); }">
                                                    <i class="icofont-search me-1 fs-6"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Total Project Hours -->
                                    <div v-if="totalProjectHours" class="mt-3">
                                        <h5><strong>Total Project Hours:</strong> {{ totalProjectHours }}</h5>
                                    </div>

                                    <div class="row clearfix g-3">
                                        <div class="col-lg-12">
                                            <div class="card mb-3">
                                                <div class="card-body p-0 mt-3 table-responsive">
                                                    <table id="reports"
                                                        class="table table-hover align-middle mb-0 mis_table"
                                                        style="width:100%">
                                                        <thead>
                                                            <tr class="reportsHeader">
                                                                <th style="width:30%; color:white">Task</th>
                                                                <th style="width:20%; color:white">Total Task Hours</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template v-for="task in reports" :key="task.task_id">
                                                                <tr :class="{ 'clickable-row': superUser || canViewAdminHours }"
                                                                    :style="{ cursor: (superUser || canViewAdminHours) ? 'pointer' : 'default' }"
                                                                    @click="(superUser || canViewAdminHours) && (task.show = !task.show)">

                                                                    <td> <router-link
                                                                            :to="{ path: 'task', query: { id: task?.task_id, activeTab: 'report' } }">
                                                                            {{ task.title }}
                                                                        </router-link>
                                                                    </td>
                                                                    <td>{{ task.task_total_formatted }}</td>
                                                                </tr>
                                                                <tr v-if="task.show" v-for="user in task.users"
                                                                    :key="user.userId" class="reports_tasks"
                                                                    style="font-weight: lighter;" >
                                                                    <td colspan="1">
                                                                        <router-link :to="`/users?id=${user.userId}`">{{
                                                                            user.username }}</router-link>
                                                                    </td>
                                                                    <td colspan="1">{{ user.task_worked_hours_formatted
                                                                        }}</td>
                                                                </tr>
                                                            </template>
                                                            <tr v-if="reports.length === 0">
                                                                <td colspan="4">No data</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div v-if="activeTab === 'search'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body searchResults">
                                    <div class="header-search">
                                        <i class="wx-ic wx-ic-search search-icon"></i>
                                        <input
                                            type="search"
                                            class="form-control form-control-sm content-search"
                                            placeholder="Search in the entire project..."
                                            v-model="contentSearch"
                                            @keyup.enter="fetchContent"
                                        />
                                    </div>
                                    <p v-if = "contentSearchResults?.length > 0"> 
                                        Results for "{{contentSearch}}"
                                    </p>
                                    <div class="resultsList" :class="{active: isActive}" v-if = "contentSearchResults?.length > 0">
                                        <table class="table active">
                                            <tbody>
                                                <tr class="rowResults" v-for="item in contentSearchResults" :key="item.id">
                                                    <td>
                                                        <router-link>
                                                            {{item.title || item.description}}
                                                        </router-link>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else-if="contentSearch && contentSearchResults?.length ===0">
                                        <p> Δε βρέθηκαν αποτελέσματα.</p>
                                    </div>
                                    <p v-if = "contentSearchResults?.length > 0"> 
                                        Number of results ({{contentSearchResults.length}})
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div v-if="activeTab === 'files'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body px-0">
                                    <iframe :src="projectViewData?.info?.shared_link"
                                        style="width: 100%; height: 500px;"></iframe>
                                </div>
                            </div>
                        </div>

                        <!-- Manager's Brief Tab -->
                        <div v-if="activeTab === 'managerBrief'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body p-1" v-if="!isEditingManagersBrief">
                                    <div v-if="projectViewData && projectViewData.info?.manager_brief">
                                        <div v-html="projectViewData.info?.manager_brief" v-target-blank></div>
                                    </div>
                                    <div v-else>
                                        <div class="text-secondary">The manager’s brief has not been provided yet.</div>
                                    </div>
                                    <!-- <div v-html="projectViewData.info?.manager_brief" v-if="projectViewData"></div> -->
                                </div>



                                <div class="card-body" v-if="isEditingManagersBrief">
                                    <div class="mb-3" v-if="projectViewData">
                                        <Editor api-key="no-api-key" :init="tinymceInit"
                                            v-model="projectViewData.info.manager_brief"></Editor>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Tasks Tab Mobile -->
                        <div class="col-xl-4 col-lg-5 col-md-4 rightCol mb-5 mb-xl-0 mobilefilters"
                            v-if="activeTab == 'tasks'">
                            <div class="card border-0 mb-2">
                                <div class="card-header py-1 px-0 d-sm-flex align-items-center justify-content-between">
                                    <div class="w-100">
                                        <button type="button" class="w-100 btn justify-content-start"
                                            style="color:var(--secondary-color);" @click="createTask"
                                            v-if="canCreateTask">
                                            <i class="icofont-plus me-2 fs-6"></i> Create Task
                                        </button>
                                    </div>
                                </div>
                                <div class="filter-section mt-3">
                                    <!-- Status Tabs -->
                                    <div>
                                        <ul class="nav nav-tabs tab-body-header rounded w-100 mb-2 align-items-center justify-content-between"
                                            role="tablist">
                                            <li class="nav-item2">
                                                <a :class="{
                                                    'nav-link text-center active': filters.statusId == '0',
                                                    'nav-link text-center': filters.statusId != '0',
                                                }" @click.prevent="() => updateFilters({ ...filters, statusId: '0', page: 1 })"
                                                    href="#" role="tab">

                                                    <span class="nav-item nav-link">All</span>
                                                </a>
                                            </li>

                                            <li class="nav-item2">
                                                <a :class="{
                                                    'nav-link text-center active': filters.statusId == '2' || filters.statusId == undefined,
                                                    'nav-link text-center': filters.statusId != '2' && filters.statusId != undefined,
                                                }" @click.prevent="() => updateFilters({ ...filters, statusId: '2', page: 1 })"
                                                    href="#" role="tab">

                                                    <span class="wx-st wx-st-progress" title="In Progress">In progress</span>
                                                </a>
                                            </li>
                                            <li class="nav-item2">
                                                <a :class="{
                                                    'nav-link text-center active': filters.statusId == '3',
                                                    'nav-link text-center': filters.statusId != '3',
                                                }" @click.prevent="() => updateFilters({ ...filters, statusId: '3', page: 1 })"
                                                    href="#" role="tab">
                                                    <span class="wx-st wx-st-done" title="Done">Done</span>
                                                </a>
                                            </li>
                                            <li class="nav-item2">
                                                <a :class="{
                                                    'nav-link text-center active': filters.statusId == '1',
                                                    'nav-link text-center': filters.statusId != '1',
                                                }" @click.prevent="() => updateFilters({ ...filters, statusId: '1', page: 1 })"
                                                    href="#" role="tab">
                                                    <span class="wx-st wx-st-hold" title="On Hold">On hold</span>
                                                </a>
                                            </li>
                                            <li class="nav-item2">
                                                <a :class="{
                                                    'nav-link text-center active': filters.statusId == '5',
                                                    'nav-link text-center': filters.statusId != '5',
                                                }" @click.prevent="() => updateFilters({ ...filters, statusId: '5', page: 1 })"
                                                    href="#" role="tab">
                                                    <span class="wx-st wx-st-ongoing" title="On going">On going</span>
                                                </a>
                                            </li>

                                            <li class="nav-item2">
                                                <a :class="{
                                                    'nav-link text-center active': filters.statusId == '4',
                                                    'nav-link text-center': filters.statusId != '4',
                                                }" @click.prevent="() => updateFilters({ ...filters, statusId: '4', page: 1 })"
                                                    href="#" role="tab">
                                                    <span class="wx-st wx-st-archived" title="Archived">Archived</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="d-flex align-items-center mb-3 justify-content-center col-md-12">
                                        <input id="main-search-input" type="search" class="form-control rounded"
                                            placeholder="Αναζήτηση..." aria-label="search"
                                            aria-describedby="addon-wrapping" />
                                    </div>
                                    <!-- Date Filters -->
                                    <div class="mb-3 d-flex align-items-center">
                                        <label for="start-date" class="form-label me-2 w-25 text-nowrap">Start
                                            date:</label>
                                        <input type="date" id="start-date" v-model="startDate"
                                            class="form-control w-100" />
                                    </div>

                                    <div class="mb-3 d-flex align-items-center">
                                        <label for="end-date" class="form-label me-2 w-25 text-nowrap">End date:</label>
                                        <input type="date" id="end-date" v-model="endDate" class="form-control w-100" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="activeTab === 'tasks'" class="tab-pane fade show active">
                            <div id="projectTableMobile" class="d-flex w-100 flex-column mobileRows gap-2"
                                v-for="(task, index) in data" :key="task.info.id"
                                :class="{ 'selected': selectedTaskIds.includes(task.info.id) }"
                                @click="toggleTaskSelection(task.info.id, $event)">
                                <div class="w-100 d-flex justify-content-between align-items-center">
                                    <div class="d-flex flex-column gap-1 col-7">
                                        <router-link :to="{ path: 'task', query: { id: task.info?.id } }">
                                            <span class="fw-bold">{{ task.info?.title }}</span>
                                        </router-link>
                                    </div>
                                    <div class="col-3">
                                        <div class="dropdown-container w-100">
                                            <!-- <button class="dropbtn w-100" :style="getStatusStyle(task.status?.id)">
                                                {{ getCurrentStatus(task.status?.id) }}
                                                <i class="fa fa-caret-down"
                                                    v-if="canEditTask(task) || canEditAllTasks || superUser"></i>
                                            </button>
                                            <div class="status-dropdown-content shadow"
                                                v-if="canEditTask(task) || canEditAllTasks || superUser">
                                                <button v-for="status in task_statuses" v-if="status?.id != 6"
                                                    :key="status.id" @click="updateTaskStatusId(task.info, status.id)"
                                                    :style="getStatusStyle(status.id)">
                                                    {{ status.description }}
                                                </button>
                                            </div> -->
                                            <button class="dropbtn w-100" :style="getStatusStyle(task.status?.id)">
                                                {{ getCurrentStatus(task.status?.id) }}
                                                <i class="fa fa-caret-down"
                                                    v-if="canEditTask(task) || canEditAllTasks || superUser"></i>
                                            </button>
                                            <div class="dropdown-content shadow"
                                                v-if="canEditTask(task) || canEditAllTasks || superUser">
                                                <button v-for="status in statuses" :key="status.id"
                                                    @click="updateStatus(task.info?.id, status.id)"
                                                    :style="getStatusStyle(status.id)">
                                                    {{ status.description }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-100 d-flex justify-content-between pb-2 align-items-center">
                                    <div>
                                        <div v-if="task.manager?.avatar_file_name" class="small-column">
                                            <img :src="`/storage/avatars/${task.manager.avatar_file_name}`" width="30"
                                                class="managerProfIcon" :title="task.manager.username">
                                        </div>
                                        <div v-else class="small-column">
                                            {{ task.manager?.username }}
                                        </div>
                                    </div>
                                    <div class="d-flex gap-2 py-1 align-items-center text-secondary ps-1">
                                        <div><i class="icofont-ui-calendar me-1"></i> {{ task.info?.startDate }}</div>
                                        <div><i class="icofont-ui-calendar me-1"></i> {{ task.info?.endDate }}</div>
                                    </div>
                                    <div class="d-flex">
                                        <div class="button-group d-flex">
                                            <div class="icon-wrapper">
                                                <router-link
                                                    :to="{ path: 'task', query: { id: task?.info?.id, activeTab: 'taskChat' } }">
                                                    <button class="btn btn-dark comments p-1">
                                                        <i class="wx-ic wx-ic-chat" title="Unread comments"></i>
                                                        <span class="unread-comments" v-if="task.unread_comments > 0">{{
                                                            task.unread_comments
                                                            }}</span>
                                                    </button>
                                                </router-link>
                                            </div>
                                            <div class="icon-wrapper"
                                                v-if="canEditTask(task) || canEditAllTasks || superUser">
                                                <button class="btn btn-dark p-1"
                                                    @click.prevent="editTask(task.info.id)">
                                                    <i class="wx-ic wx-ic-edit" title="Edit"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <!-- Tasks Tab -->
                        <div v-if="activeTab === 'tasks'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body ">
                                    <table id="myProjectTable"
                                        class="table-responsive table table-hover align-middle mb-0 mis_table"
                                        style="width:100%">
                                        <thead>
                                            <tr>
                                                <th class="text-start">Task <i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('tasks.title')"></i></th>
                                                <th style="width: 5%">
                                                    <div v-if="superUser" class="d-flex align-items-center">
                                                        <div class="custom-dropdown">
                                                            <!-- Dropdown Button -->
                                                            <div class="dropdown-btn" @click="toggleDropdown">
                                                                <span>{{ selectedManager?.username || 'Επιλογη Manager'
                                                                    }}</span>
                                                                <i class="icofont-rounded-down"></i>
                                                            </div>

                                                            <!-- Dropdown List -->
                                                            <ul v-if="isDropdownOpen" class="dropdown-options">
                                                                <!-- All Managers Option -->
                                                                <li
                                                                    @click="selectManager({ id: null, username: 'All Managers' })">
                                                                    All Managers
                                                                    <img src="../assets/images/icons8-superman.svg"
                                                                        alt="Superman Icon" class="menu-img ms-2"
                                                                        style="width: 1.5em" />
                                                                </li>

                                                                <!-- Managers List -->
                                                                <li v-for="manager in managers" :key="manager.id"
                                                                    @click="selectManager(manager)">
                                                                    {{ manager.username }}
                                                                    <img v-if="String(manager.id) !== currentUserId()"
                                                                        src="../assets/images/icons8-superman.svg"
                                                                        alt="Superman Icon" class="menu-img ms-2"
                                                                        style="width: 1.5em" />
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    <!-- Non-superUser Fallback -->
                                                    <div v-else>
                                                        Manager
                                                        <i class="fa fa-sort sorting-icon"
                                                            @click.prevent="sortBy('m.username')"></i>
                                                    </div>
                                                </th>


                                                <th>Start Date<i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('tasks.startDate')"></i>
                                                </th>
                                                <th>End Date<i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('tasks.endDate')"></i>
                                                </th>
                                                <th>Status <i class="fa fa-sort sorting-icon"
                                                        @click.prevent="sortBy('tasks.statusId')"></i>
                                                </th>
                                                <th class="no-after"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(task, index) in data" :key="task.info.id" @click="handleRowClick(task.info?.id, $event)">
                                                <td class="text-start">
                                                    <router-link :to="{ path: 'task', query: { id: task.info?.id } }">
                                                        {{ task.info?.title }}
                                                    </router-link>
                                                </td>
                                                <td>
                                                    <img class="managerProfIcon" v-if="task.manager?.avatar_file_name"
                                                        :src="`/storage/avatars/${task.manager.avatar_file_name}`"
                                                        width="35" :title="task.manager.username">
                                                    <span v-else> {{ task.manager?.username }} </span>
                                                </td>
                                                <td>{{ task.info?.startDate }}</td>
                                                <td>{{ task.info?.endDate }}</td>
                                                <td>
                                                    <!-- Custom Status Dropdown for Each Task -->
                                                    <div class="status-dropdown">
                                                        <button class="status-button">
                                                            <span class="wx-status-pill" :style="getStatusStyle(task.status?.id)">{{ getCurrentStatus(task.status?.id) }}</span>
                                                            <!-- <i :class="getStatusIcon(task.status.id)"></i>
                                                            {{ getCurrentStatus(task.status.id) }} -->
                                                            <i class="fa fa-caret-down"
                                                                v-if="canEditProject(projectViewData) || canEditAllProjects || superUser"></i>
                                                        </button>
                                                        <div class="status-dropdown-content-tasks"
                                                            v-if="canEditProject(task) || canEditAllProjects || superUser">
                                                            <!-- <button v-for="status in task_statuses"
                                                                v-if="status?.id != 6" :key="status.id"
                                                                :style="getStatusStyle(status?.id)"
                                                                @click="updateTaskStatusId(task.info, status.id)"
                                                                :class="{ 'active-status': task.status.id === status.id }"> -->
                                                            <button v-for="status in task_statuses"
                                                                v-if="status?.id != 6" :key="status.id"
                                                                @click="updateTaskStatusId(task.info, status.id)"
                                                                :class="{ 'active-status': task.status.id === status.id }">
                                                                <span class="wx-status-pill" :style="getStatusStyle(status?.id)">{{ getCurrentStatus(status?.id) }}</span>
                                                                <!-- {{ status.description }} -->
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div class="button-group">
                                                        <div class="icon-wrapper">
                                                            <router-link
                                                                :to="{ path: 'task', query: { id: task?.info?.id, activeTab: 'taskChat' } }">

                                                                <button class="btn p-2 btn-dark">
                                                                    <i class="wx-ic wx-ic-chat" title="Unread comments"></i>
                                                                    <span class="unread-comments"
                                                                        v-if="task.unread_comments > 0">{{
                                                                        task.unread_comments }}</span>
                                                                </button></router-link>
                                                        </div>
                                                        <!--  <div class="icon-wrapper">
                                                        <button class="btn btn-dark"
                                                            @click.prevent="editTask(task.info.id)"
                                                            v-if="canEditTask(task) || canEditAllTasks || superUser">
                                                            <i class="wx-ic wx-ic-edit" title="Edit"></i>
                                                        </button>
                                                    </div>
                                                    <div class="icon-wrapper">
                                                        <button class="btn btn-dark"
                                                            @click.prevent="openArchiveConfirmation(task.info?.id)"
                                                            v-if="canArchiveTask || superUser">
                                                            <i class="wx-ic wx-ic-trash" title="Archive"></i>
                                                        </button>
                                                    </div> -->
                                                    </div>
                                                </td>

                                            </tr>
                                            <tr v-if="!data || !data.length">
                                                <td colspan="6" class="text-center">No tasks found</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <nav aria-label="Page navigation">
                                        <ul class="pagination mt-4"
                                            v-if="paginationLinks && paginationLinks.length > 0">
                                            <li class="page-item" v-for="(paginationLink, index) in paginationLinks"
                                                :key="index" :class="{ active: paginationLink.active }">
                                                <router-link
                                                    :to="{ path: 'project', query: { ...filters, page: getPageFromUrl(paginationLink.url) } }"
                                                    v-if="paginationLink.url">
                                                    <span class="page-link" v-html="paginationLink.label"></span>
                                                </router-link>
                                                <span class="page-link" v-else v-html="paginationLink.label"></span>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>

                        <!-- Project Chat Tab -->
                        <div v-if="activeTab === 'projectChat'" class="tab-pane fade show active">
                            <div class="card">
                                <div class="card-body">
                                    <!-- Chat History List -->
                                    <ul ref="chatHistory" class="chat-history list-unstyled">
                                        <li class="mb-3 d-flex" v-if="projectViewData && projectViewData.comments"
                                            v-for="comment in projectViewData.comments" :key="comment.id" :class="{
                                                'justify-content-end': comment.author?.id == currentUser,
                                                'justify-content-start': comment.author?.id != currentUser
                                            }">
                                            <!-- Author's Info and Message -->
                                            <div class="authorsChatDiv" style="width:50%;">
                                                <span class="text-muted small d-flex align-items-center" :class="{
                                                    'justify-content-end': comment.author?.id == currentUser,
                                                    'justify-content-start': comment.author?.id != currentUser
                                                }">
                                                    <img v-if="comment.author?.avatar_file_name"
                                                        :src="`/storage/avatars/${comment.author?.avatar_file_name}`"
                                                        width="25" class="me-2" style="width: 2.5rem;
                                                        height: 2.5rem;
                                                        border-radius: 50%;" :title="comment.author.username" />
                                                    <h6 v-else class="fw-bolder">{{ comment.author.username }}</h6>
                                                </span>
                                                <div class="chat-message p-2 mt-1 rounded"
                                                    v-html="parseLinks(comment.info?.comment)">
                                                </div>
                                                <span class="text-muted small">
                                                    <i class="icofont icofont-date"></i><i class="wx-ic wx-ic-calendar" title="Edit"></i>{{ comment.info.created_at
                                                    }}
                                                </span>
                                                <div class="mt-1 d-flex align-items-center justify-content-end"
                                                    v-if="comment.read_by_users && comment.read_by_users.length">
                                                    <span class="me-2 text-muted small">Διαβάστηκε από:</span>
                                                    <div class="d-flex align-items-center avatar-stack">
                                                        <div v-for="(user, index) in comment.read_by_users"
                                                            :key="user.id" :title="user.username" class="avatar-wrapper"
                                                            :style="{ left: `${index * 16}px` }">
                                                            <img v-if="user.avatar_file_name"
                                                                :src="`/storage/avatars/${user.avatar_file_name}`"
                                                                :alt="user.username"
                                                                class="rounded-circle border avatar-img" />
                                                            <span v-else class="avatar-text">{{
                                                                user.username.charAt(0).toUpperCase() }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>

                                    <!-- Message Input Section -->
                                    <div class="d-flex align-items-end gap-2">
                                        <textarea id="commentTextarea" class="form-control position-relative"
                                            placeholder="Μήνυμα..." v-model="newComment" @input="filterUsernames"
                                            @keydown.enter.prevent="submitComment"></textarea>

                                        <!-- Autocomplete Dropdown -->
                                        <div v-if="showAutocomplete" class="autocomplete-dropdown"
                                            :style="{ top: `${dropdownTop}px`, left: `${dropdownLeft}px` }">
                                            <ul class="list-unstyled m-0 p-2">
                                                <li v-for="user in filteredUsernames" :key="user.id"
                                                    @click="selectUsername(user.username)" class="autocomplete-item">
                                                    {{ user.username }}
                                                </li>
                                            </ul>
                                        </div>
                                        <button @click.prevent="submitComment" class="btn sendComment">
                                            <i class="fa fa-paper-plane"></i>
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- Right Column with Project Details -->
                <div class="col-xl-4 col-lg-5 col-md-12 mb-xl-0 mb-5" v-if="activeTab != 'tasks' && projectViewData">
                    <div class="card wx-details">
                        <div class="card-body">
                            <button class="btn btn-dark p-1 belowEditbtn"
                                v-if="!isEditingGeneral && (superUser || canEditAllProjects || canEditProject(projectViewData))"
                                @click="editProjectGeneral" style="position: absolute; top: 25px; right: 10px;">
                                <i class="wx-ic wx-ic-edit" title="Edit"></i>
                            </button>

                            <!-- Save Button -->
                            <button class="btn btn-secondary mb-0 mb-xl-3 p-1" @click="saveGeneral"
                                v-if="isEditingGeneral" style="position: absolute; top: 25px; right: 10px;">

                                <i class="wx-ic wx-ic-check" title="Save"></i>
                            </button>

                            <!-- Cancel Button -->
                            <button class="btn btn-danger mt-2 p-1" @click="cancelEditingGeneral"
                                v-if="isEditingGeneral" style="position: absolute; top: 65px; right: 10px;">
                                <!-- <i class="icofont-close text-white" style="font-size: 2em"></i> -->
                                <i class="wx-ic wx-ic-x" title="Cancel"></i>
                            </button>

                            <div class="row px-xl-4 px-1 gap-3" v-if="!isEditingGeneral">
                                <div class="d-flex-mob">
                                    <div class="col-6 col-xl-12 fs-6 mb-xl1 mb-0 p-0 dateprojectdiv px-0">
                                        <i class="wx-ic wx-ic-calendar me-1" title="Edit"></i>
                                        <span>Start Date: <strong>{{ projectViewData.info.startDate }}</strong></span>
                                    </div>
                                    <div class="col-6 col-xl-12 fs-6 p-0 dateprojectdiv">
                                        <i class="wx-ic wx-ic-calendar me-1" title="Edit"></i>
                                        <span>End Date: <strong>{{ projectViewData.info.endDate }}</strong></span>
                                    </div>
                                </div>
                                <br /><br />
                                <div class="col-12 gap-2 align-items-center mb-1" style="display: inline-flex;"><strong>
                                        Creator: </strong> <img v-if="projectViewData?.creator.avatar_file_name"
                                        :src="`/storage/avatars/${projectViewData?.creator?.avatar_file_name}`"
                                        width="35" :title="projectViewData.creator.username" class="managerProfIcon" />
                                    <span v-else class="avatar-text2" :title="projectViewData.creator.username"> {{
                                        projectViewData.creator.username.charAt(0).toUpperCase() }}</span>
                                </div>
                                <div class="col-12 gap-2 align-items-center mb-1" style="display: inline-flex;"><strong>
                                        Manager: </strong> <img v-if="projectViewData?.manager.avatar_file_name"
                                        :src="`/storage/avatars/${projectViewData?.manager?.avatar_file_name}`"
                                        width="35" :title="projectViewData.manager.username" class="managerProfIcon" />
                                    <span v-else class="avatar-text2" :title="projectViewData.manager.username"> {{
                                        projectViewData.manager.username.charAt(0).toUpperCase() }}</span>
                                </div>
                                <div class="col-12 gap-2 d-flex align-items-center mb-1" style="display: inline-flex;">
                                    <div class="col-12 gap-2 d-flex align-items-center flex-wrap"><strong> Assigned
                                            Users: </strong>
                                        <div v-for="user in projectViewData.assigned" :key="user.id"
                                            style="display: inline-flex; align-items: center;">
                                            <img v-if="(user?.avatar_file_name && user?.active === 1)"
                                                :src="`/storage/avatars/${user.avatar_file_name}`" width="25"
                                                :title="user.username" class="managerProfIcon" />
                                            <span v-if="!user?.avatar_file_name && user?.active === 1"
                                                class="avatar-text2" :title="user.username"> {{
                                                user.username.charAt(0).toUpperCase() }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mb-2"><strong>Client:</strong>
                                    <router-link :to="{ path: 'client', query: { id: projectViewData.client.id } }"
                                        v-if="superUser || canViewAllClients">

                                        {{ projectViewData.client.nickname }}

                                    </router-link>
                                    <span v-else>
                                        {{ projectViewData.client.nickname }}</span>
                                </div>
                                <div class="col-12 mb-2"><strong>Service:</strong> {{ projectViewData.service.title }}
                                </div>
                                <div class="col-12 mb-2"><strong>Payable:</strong> {{ projectViewData.info.payable ?
                                    "Yes" :
                                    "No" }}</div>
                                <div class="col-12 mb-2" v-if="projectViewData.info.payable == '1'">
                                    <strong>Pay Manager:</strong>{{ projectViewData.payManager?.username }}

                                </div>
                                <div class="col-12 mb-2" v-if="projectViewData.info.payable == '1'">
                                    <strong>Paid:</strong> {{
                                    projectViewData.info.paid ? "Yes" : "No" }}
                                </div>
                                <div class="col-12 mb-2" v-if="projectViewData.info.payable == '1'">
                                    <strong>Invoiced:</strong> {{ projectViewData.info.invoiced ? "Yes" : "No" }}
                                </div>
                            </div>

                            <div class="row" v-if="isEditingGeneral" style="max-width: 800px; margin: auto;">
                                <!-- Start Date -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <label class="form-label mb-0">Start Date:</label>
                                    </div>
                                    <div class="col-md-8">
                                        <input type="date" class="form-control" v-model="projectData.startDate" />
                                    </div>
                                </div>

                                <!-- End Date -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <label class="form-label mb-0">End Date:</label>
                                    </div>
                                    <div class="col-md-8">
                                        <input type="date" class="form-control" v-model="projectData.endDate" />
                                    </div>
                                </div>

                                <!-- Creator -->
                                <div class="col-12 row mb-3" v-if="superUser || canEditProjectCreator">
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <label class="form-label mb-0">Creator:</label>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 :options="allData.users" v-model="projectData.createdBy"
                                            :settings="select2SettingsProject" class="form-control" />
                                    </div>
                                </div>

                                <!-- Manager -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <label class="form-label mb-0">Manager:</label>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 ref="managerSelect" :options="filteredUsersForManager"
                                            v-model="projectData.managerId" :settings="select2SettingsProject"
                                            class="form-control" id="taskManager" />
                                    </div>
                                </div>

                                <!-- Assigned Users -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <label class="form-label mb-0">Assigned Users:</label>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 ref="assignedUsersSelect" :options="filteredUsersForAssigned"
                                            v-model="projectData.assignedUsers"
                                            :settings="{ ...select2SettingsProject, multiple: true }"
                                            class="form-control" id="assignedUsers" />
                                    </div>
                                </div>

                                <!-- Client -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <label class="form-label mb-0">Client:</label>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 :options="allData.clients" v-model="projectData.clientId"
                                            :settings="select2SettingsProject" class="form-control" />
                                    </div>
                                </div>

                                <!-- Services -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <label class="form-label mb-0">Services:</label>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 :options="allData.services" v-model="projectData.serviceId"
                                            :settings="select2SettingsProject" class="form-control" />
                                    </div>
                                </div>

                                <!-- Payable -->
                                <div class="col-12 row mb-3">
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <label class="form-label mb-0">Payable:</label>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 :options="[
                                            { id: '', text: 'Παρακαλώ επιλέξτε' },
                                            { id: '0', text: 'No' },
                                            { id: '1', text: 'Yes' }
                                        ]" v-model="projectData.payable" :settings="select2SettingsProject" class="form-control" />
                                    </div>
                                </div>

                                <!-- Pay Manager -->
                                <div class="col-12 row mb-3" v-if="projectData.payable == '1'">
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <label class="form-label mb-0">Pay Manager:</label>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 :options="allData.users" v-model="projectData.payManagerId"
                                            :settings="select2SettingsProject" class="form-control" />
                                    </div>
                                </div>

                                <!-- Invoiced -->
                                <div class="col-12 row mb-3" v-if="projectData.payable == '1'">
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <label class="form-label mb-0">Invoiced:</label>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 :options="[
                                            { id: '', text: 'Παρακαλώ επιλέξτε' },
                                            { id: '0', text: 'No' },
                                            { id: '1', text: 'Yes' }
                                        ]" v-model="projectData.invoiced" :settings="select2SettingsProject" class="form-control" />
                                    </div>
                                </div>

                                <!-- Paid -->
                                <div class="col-12 row mb-3" v-if="projectData.payable == '1'">
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <label class="form-label mb-0">Paid:</label>
                                    </div>
                                    <div class="col-md-8">
                                        <Select2 :options="[
                                            { id: '', text: 'Παρακαλώ επιλέξτε' },
                                            { id: '0', text: 'No' },
                                            { id: '1', text: 'Yes' }
                                        ]" v-model="projectData.paid" :settings="select2SettingsProject" class="form-control" />
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>

                <!-- Right Column with Project Details -->
                <div class="col-xl-4 col-lg-5 col-md-4 rightCol mb-5 mb-xl-0 desktopfilters"
                    v-if="activeTab == 'tasks'">
                    <div class="card border-0 mb-2">
                        <div class="card-header py-1 px-0 d-sm-flex align-items-center justify-content-between">
                            <div class="w-100">
                                <button type="button" class="w-100 btn justify-content-start"
                                    style="color:var(--secondary-color);" @click="createTask" v-if="canCreateTask">
                                    <i class="icofont-plus me-2 fs-6"></i> Create Task
                                </button>
                            </div>
                        </div>
                        <div class="filter-section mt-3">
                            <!-- Status Tabs -->
                            <div>
                                <ul class="nav nav-tabs tab-body-header rounded w-100 mb-2 align-items-center justify-content-between"
                                    role="tablist">
                                    <li class="nav-item2">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '0',
                                            'nav-link text-center': filters.statusId != '0',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '0', page: 1 })"
                                            href="#" role="tab">

                                            <span class="nav-item nav-link">All</span>
                                        </a>
                                    </li>

                                    <li class="nav-item2">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '2' || filters.statusId == undefined,
                                            'nav-link text-center': filters.statusId != '2' && filters.statusId != undefined,
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '2', page: 1 })"
                                            href="#" role="tab">

                                            <span class="wx-st wx-st-progress" title="In Progress">In progress</span>
                                        </a>
                                    </li>
                                    <li class="nav-item2">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '3',
                                            'nav-link text-center': filters.statusId != '3',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '3', page: 1 })"
                                            href="#" role="tab">
                                            <span class="wx-st wx-st-done" title="Done">Done</span>
                                        </a>
                                    </li>
                                    <li class="nav-item2">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '1',
                                            'nav-link text-center': filters.statusId != '1',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '1', page: 1 })"
                                            href="#" role="tab">
                                            <span class="wx-st wx-st-hold" title="On Hold">On hold</span>
                                        </a>
                                    </li>
                                    <li class="nav-item2">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '5',
                                            'nav-link text-center': filters.statusId != '5',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '5', page: 1 })"
                                            href="#" role="tab">
                                            <span class="wx-st wx-st-ongoing" title="On going">On going</span>
                                        </a>
                                    </li>

                                    <li class="nav-item2">
                                        <a :class="{
                                            'nav-link text-center active': filters.statusId == '4',
                                            'nav-link text-center': filters.statusId != '4',
                                        }" @click.prevent="() => updateFilters({ ...filters, statusId: '4', page: 1 })"
                                            href="#" role="tab">
                                            <span class="wx-st wx-st-archived" title="Archived">Archived</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div class="d-flex align-items-center mb-3 justify-content-center col-md-12">
                                <input id="main-search-input2" type="search" class="form-control rounded"
                                    placeholder="Αναζήτηση..." aria-label="search" aria-describedby="addon-wrapping" />
                            </div>
                            <!-- Date Filters -->
                            <div class="mb-3 d-flex align-items-center">
                                <label for="start-date" class="form-label me-2 w-25 text-nowrap">Start date:</label>
                                <input type="date" id="start-date" v-model="startDate" class="form-control w-100" />
                            </div>

                            <div class="mb-3 d-flex align-items-center">
                                <label for="end-date" class="form-label me-2 w-25 text-nowrap">End date:</label>
                                <input type="date" id="end-date" v-model="endDate" class="form-control w-100" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Create Project-->
                <div class="modal fade" id="create-project-form" tabindex="-1" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title fw-bold" id="createprojectlLabel">Edit Project</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div class="mb-3">
                                    <label for="projectTitle" class="form-label" aria-label="Title"
                                        aria-placeholder="Title">Title</label>
                                    <input type="text" class="form-control" id="projectTitle" placeholder="Title"
                                        name="title" v-model="projectData.description" v-if="projectData">
                                </div>
                                <div class="mb-3"
                                    v-if="(projectData && projectData.createdBy == currentUserInfo?.id) || superUser">
                                    <label for="projectDescriptionTinyMce" class="form-label">Creator's brief</label>
                                    <Editor api-key="no-api-key" :init="tinymceInit" v-model="projectData.body">
                                    </Editor>
                                </div>
                                <div class="mb-3"
                                    v-if="(projectData && currentUserInfo && projectData.managerId == currentUserInfo.id)">
                                    <label for="projectManagerBriefTinyMce" class="form-label">Manager's brief</label>
                                    <Editor api-key="no-api-key" :init="tinymceInit"
                                        v-model="projectData.manager_brief"></Editor>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Client</label>
                                    <Select2 :options="allData.clients" v-model="projectData.clientId"
                                        :settings="select2SettingsProject" />
                                </div>
                                <div class="mb-3" v-if="superUser || canEditProjectCreator">
                                    <label class="form-label">Creator</label>
                                    <Select2 :options="allData.users" v-model="projectData.createdBy"
                                        :settings="select2SettingsProject" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Status</label>
                                    <Select2 :options="allData.statuses" v-model="projectData.statusId"
                                        :settings="select2SettingsProject" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Services</label>
                                    <Select2 :options="allData.services" v-model="projectData.serviceId"
                                        :settings="select2SettingsProject" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Manager</label>
                                    <Select2 ref="managerSelect" :options="filteredUsersForManager"
                                        v-model="projectData.managerId" :settings="select2SettingsProject" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Assigned users</label>
                                    <Select2 ref="assignedUsersSelect" :options="filteredUsersForAssigned"
                                        v-model="projectData.assignedUsers"
                                        :settings="{ ...select2SettingsProject, multiple: true }" />
                                </div>
                                <div class="mb-3 payable-container">
                                    <div class="mb-3">
                                        <label class="form-label">Payable</label>
                                        <Select2
                                            :options="[{ id: '', text: 'Παρακαλώ επιλέξτε' }, { id: '0', text: 'No' }, { id: '1', text: 'Yes' }]"
                                            v-model="projectData.payable" :settings="select2SettingsProject" />
                                    </div>
                                    <div class="payable-fields" v-if="projectData.payable == '1'">
                                        <div class="mb-3">
                                            <label class="form-label">Pay Manager</label>
                                            <Select2 :options="allData.users" v-model="projectData.payManagerId"
                                                :settings="select2SettingsProject" />
                                        </div>
                                        <div class="mb-3">
                                            <label class="form-label">Invoiced</label>
                                            <Select2
                                                :options="[{ id: '', text: 'Παρακαλώ επιλέξτε' }, { id: '0', text: 'No' }, { id: '1', text: 'Yes' }]"
                                                v-model="projectData.invoiced" :settings="select2SettingsProject" />
                                        </div>
                                        <div class="mb-3">
                                            <label class="form-label">Paid</label>
                                            <Select2
                                                :options="[{ id: '', text: 'Παρακαλώ επιλέξτε' }, { id: '0', text: 'No' }, { id: '1', text: 'Yes' }]"
                                                v-model="projectData.paid" :settings="select2SettingsProject" />
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="projectEstimatedHours" class="form-label" aria-label="Estimated hours"
                                        aria-placeholder="Estimated hours">Estimated hours</label>
                                    <input type="number" class="form-control" id="projectEstimatedHours"
                                        placeholder="Estimated hours" aria-label="Estimated hours"
                                        aria-placeholder="Estimated hours" name="estimatedHours"
                                        v-model="projectData.estimatedTime">
                                </div>
                                <div class="deadline-form">
                                    <form>
                                        <div class="row g-3 mb-3">
                                            <div class="col">
                                                <label for="projectStartDate" class="form-label">Start Date</label>
                                                <input type="date" class="form-control" id="projectStartDate"
                                                    name="startDate" v-model="projectData.startDate">
                                            </div>
                                            <div class="col">
                                                <label for="projectEndDate" class="form-label">End Date</label>
                                                <input type="date" class="form-control" id="projectEndDate"
                                                    name="endDate" v-model="projectData.endDate">
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div id="create-project-errors"></div>
                            </div>
                            <div class="modal-footer">
                                <!--<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>-->
                                <button type="button" class="btn btn-secondary"
                                    @click.prevent="submitForm">Update</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Files Modal -->
                <div class="modal fade" id="filesModal" tabindex="-1" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Project Files</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <iframe v-if="projectViewData && projectViewData.info?.shared_link"
                                    :src="projectViewData.info?.shared_link" width="100%" height="600px"></iframe>
                                <p v-else>No shared link available for this project.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="unsavedChangesModal" tabindex="-1" aria-labelledby="unsavedChangesLabel"
                    aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="unsavedChangesLabel">Unsaved Changes</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                You have unsaved changes. Are you sure you want to leave this page?
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-sm btn-secondary"
                                    data-bs-dismiss="modal">Cancel</button>
                                <button type="button" class="btn btn-sm btn-danger text-white"
                                    @click="confirmLeave">Leave</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="archiveConfirmationModal" tabindex="-1" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Confirm Archive</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                Are you sure you want to archive this task?
                            </div>
                            <div class="modal-footer">
                                <!--                     <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
 --> <button type="button" class="btn btn-secondary" @click="confirmArchive">Confirm</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Create Task-->
                <div class="modal fade" id="create-task-form" tabindex="-1" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title fw-bold">New task</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <input type="hidden" name="id" id="ïd" v-model="taskData.id">
                                <div class="mb-3">
                                    <label for="projectTitle" class="form-label" aria-label="Title"
                                        aria-placeholder="Title">Title</label>
                                    <input type="text" class="form-control" id="projectTitle" placeholder="Title"
                                        name="title" v-model="taskData.title">
                                </div>
                                <div class="mb-3"
                                    v-if="(taskData && (taskData.createdBy == currentUserInfo?.id)) || superUser || taskData.createdBy == '' || taskData.createdBy == null">
                                    <label class="form-label">Creator's brief <sup>*</sup></label>
                                    <Editor api-key="no-api-key" :init="tinymceInit" v-model="taskData.body"></Editor>
                                </div>
                                <div class="mb-3"
                                    v-if="(taskData && currentUserInfo && taskData.managerId == currentUserInfo.id)">
                                    <label class="form-label">Manager's brief</label>
                                    <Editor api-key="no-api-key" :init="tinymceInit" v-model="taskData.manager_brief">
                                    </Editor>
                                </div>
                                <div class="mb-3" v-if="superUser || canEditTaskCreator">
                                    <label class="form-label">Creator</label>
                                    <Select2 :options="allData.users" v-model="taskData.createdBy"
                                        :settings="select2SettingsProject" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Status</label>
                                    <Select2 :options="allData.statuses" v-model="taskData.statusId"
                                        :settings="select2SettingsTask" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Manager<sup>*</sup></label>
                                    <Select2 ref="managerSelectTask" :options="filteredUsersForManagerTask"
                                        v-model="taskData.managerId" :settings="select2SettingsTask" />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Assigned users</label>
                                    <Select2 ref="assignedUsersSelectTask" :options="filteredUsersForAssignedTask"
                                        v-model="taskData.assignedUsers"
                                        :settings="{ ...select2SettingsTask, multiple: true }" />
                                </div>
                                <div class="mb-3">
                                    <label for="projectEstimatedHours" class="form-label" aria-label="Estimated hours"
                                        aria-placeholder="Estimated hours">Estimated hours</label>
                                    <input type="number" class="form-control" id="projectEstimatedHours"
                                        placeholder="Estimated hours" aria-label="Estimated hours"
                                        aria-placeholder="Estimated hours" name="totalHours"
                                        v-model="taskData.totalHours">
                                </div>
                                <div class="deadline-form">
                                    <form>
                                        <div class="row g-3 mb-3">
                                            <div class="col">
                                                <label for="projectStartDate" class="form-label">Start Date<sup>*</sup></label>
                                                <input type="date" class="form-control" id="projectStartDate"
                                                    name="startDate" v-model="taskData.startDate">
                                            </div>
                                            <div class="col">
                                                <label for="projectEndDate" class="form-label">End Date<sup>*</sup></label>
                                                <input type="date" class="form-control" id="projectEndDate"
                                                    name="endDate" v-model="taskData.endDate">
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div id="create-project-errors"></div>
                            </div>
                            <div class="modal-footer">
                                <!--                     <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
 -->                            <button type="button" class="btn btn-secondary" @click.prevent="submitTaskForm">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { initials, daysLeft, editorSkin } from '@/wxHelpers';
import { statusStyle } from '@/status';
import { onMounted, onUnmounted, ref, watch, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useFetchData } from '@/composables/useFetchData';
import { fetchUserInfo } from '@/services/user';
import { get as getProject } from "@/services/projects";
import { createOrUpdate as createOrUpdateProject, updateInfo, updateManager, updateGeneral, getReportData, searchContent } from '@/services/projects';
import { createOrUpdate as createOrUpdateTask } from '@/services/tasks';
import { useToast } from 'vue-toastification';
import { getClientsServicesStatusesUsers } from '@/services/projects';
import { fetchAll } from '@/services/tasks';
import Editor from '@tinymce/tinymce-vue';
import Select2 from 'vue3-select2-component';
import { get as getTask } from '@/services/tasks';
import { mapGetters } from 'vuex';
import { updateTaskStatus } from '@/services/followup';
import { massArchiveTasks } from '@/services/tasks';
import { updateProjectStatus } from '@/services/todo';
import { createComment } from '@/services/projects';
import { fetchManagers } from '@/services/followup';
import apiClient from '@/services/api';
import { computed } from 'vue';

export default {
    name: 'Projects',
    components: {
        Editor,
        Select2
    },
    data() {
        return {
            reports: [],
            statuses: [],
            statusesReport: [],
            totalProjectHours: '',

            filtersReport: {
                dateFrom: '',
                dateTo: '',
                userId: [],
                statusId: []
            },
            projectReports: [],
            showUnsavedModal: false,
            pendingNavigation: null, // Store pending navigation details
            newComment: '',
            showAutocomplete: false,
            filteredUsernames: [],
            isEditingInfo: false,
            isEditingGeneral: false,
            isEditingManagersBrief: false,
            projectViewData: {
                client: {
                    nickname: null, // Default to null or an empty string
                },
            },
        };
    },
    methods: {
        initials,
        daysLeft,
        currentUserId() {
            return localStorage.getItem('current_user_id');
        },
        async fetchReportData() {
            const { dateFrom, dateTo, userId, statusId } = this.filtersReport; // Access filtersReport correctly
            const projectId = this.$route.query.id; // Use route query to get the projectId

            try {
                // Prepare the data to send in the request
                const requestData = {
                    date_from: dateFrom,
                    date_to: dateTo,
                    statusId: Array.isArray(statusId) ? statusId : [statusId],
                    userId: Array.isArray(userId) ? userId : [userId],
                    project_id: projectId // Pass the project ID to the API
                };

                // Call getReportData from the services file
                const response = await getReportData({
                    date_from: dateFrom,
                    date_to: dateTo,
                    userId: Array.isArray(userId) ? userId : [userId],
                    statusId: Array.isArray(statusId) ? statusId : [statusId],
                    projectId: projectId // Pass the projectId in the body or as part of the URL path
                });

                // Check if the response is successful and handle the data
                if (response.data.success) {
                    this.reports = response.data.data.data.tasks.map(task => ({
                        ...task,
                        show: false, // Add show property to toggle task details
                    }));
                    this.totalProjectHours = response.data.data.data.total_project_hours;
                    this.statuses = response.data.data.data.project_statuses;
                } else {
                    console.error('Failed to fetch report data:', response.data.message);
                }
            } catch (error) {
                console.error('Error fetching report data:', error);
            }
        },
        scrollToBottom() {
            // Scroll the chat container to the bottom
            const chatHistory = this.$refs.chatHistory;
            if (chatHistory) {
                chatHistory.scrollTop = chatHistory.scrollHeight;
            }
        },
        confirmLeave() {
            this.resetEditingStates();
            if (this.pendingNavigation) {
                this.pendingNavigation();
                this.pendingNavigation = null;
            }
            const modal = $('#unsavedChangesModal');
            modal.modal('hide');
        },
        parseLinks(text) {
            if (!text) return '';

            const urlRegex = /(https?:\/\/[^\s]+)/g;
            return text.replace(urlRegex, function (url) {
                return `<a href="${url}" target="_blank" class="link_url underline">${url}</a>`;
            });
        },

        handleRowClick(taskId, event) {
            // Prevent navigation if it's a selection click or came from a control (like button, checkbox, etc.)
            if (event.target.closest('button, a, input, [data-stop-propagation]')) return;

            this.$router.push({ path: 'task', query: { id: taskId } });
        },
        
        resetEditingStates() {
            this.isEditingInfo = false;
            this.isEditingManagersBrief = false;
            this.isEditingGeneral = false;
        },
        canEditProject(project) {
            if (!project) return false;
            return localStorage.getItem('current_user_id') == project.info?.createdBy && this.userPermissionsProjects?.edit === 1;
        },

        editProject() {
            this.isEditingInfo = true;
        },
        editProjectManager() {
            this.isEditingManagersBrief = true;
        },

        cancelEditing() {
            this.isEditingInfo = false;

        },
        cancelEditingManager() {
            this.isEditingManagersBrief = false;

        },
        toggleHours(projectId) {
            const project = this.projectReports.find((r) => r.projectId === projectId);
            project.show_hours = !project.show_hours;
        },
        canEditTask(task) {
            if (!task) return false;
            return localStorage.getItem('current_user_id') == task.info?.createdBy && this.userPermissionsTasks?.edit === 1;
        },

        async saveInfo() {
            try {
                // Prepare the payload with both `id` and `body`
                const payload = {
                    id: this.$route.params.id, // ID from route parameters
                    body: this.projectViewData.info.body // Editor content
                };

                const toast = useToast();


                // Call the updateInfo service with the correct payload
                const response = await updateInfo(this.projectViewData.info);

                // Show success message

                if (response.data.success) {
                    toast.success(response.data.message);
                } else {
                    toast.error(response.data.message);
                }

                // Exit editing mode
                this.isEditingInfo = false;
            } catch (error) {
                // Handle any errors that occur during the API call
                console.error('Error updating information:', error);
            }
        },

        async saveManager() {
            try {
                // Prepare the payload with both `id` and `body`
                const payload = {
                    id: this.$route.params.id, // ID from route parameters
                    manager_brief: this.projectViewData.info.manager_brief // Editor content
                };

                const toast = useToast();


                // Call the updateInfo service with the correct payload
                const response = await updateManager(this.projectViewData.info);

                // Show success message
                if (response.data.success) {
                    toast.success(response.data.message);
                } else {
                    toast.error(response.data.message);
                }

                // Exit editing mode
                this.isEditingManagersBrief = false;
            } catch (error) {
                // Handle any errors that occur during the API call
                console.error('Error updating information:', error);
            }
        },
        scrollToEnd() {
            this.$nextTick(() => {
                const chatHistory = this.$refs.chatHistory;
                if (chatHistory) {
                    chatHistory.scrollTop = chatHistory.scrollHeight;
                }
            });
        },

        submitComment() {
            // Your submit comment logic here
            this.scrollToEnd(); // Scroll to end after adding new comment
        },
        async fetchManagersData() {
            try {
                const response = await fetchManagers();
                if (response.data.success) {
                    this.managers = response.data.data;
                }
            } catch (error) {
                console.error('Failed to fetch managers:', error);
            }
        },
        async fetchCreatorsData() {
            try {
                const response = await fetchManagers();
                if (response.data.success) {
                    this.creators = response.data.data;
                } else {
                    console.error("Failed to fetch creators:", response.data.message);
                }
            } catch (error) {
                console.error("Failed to fetch creators:", error);
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.isEditingInfo || this.isEditingManagersBrief || this.isEditingGeneral) {
            this.pendingNavigation = next;
            const modal = $('#unsavedChangesModal');
            modal.modal('show');
        } else {
            next();
        }
    },
    mounted() {
        // Initial scroll to end after the component mounts
        this.scrollToEnd();
        this.fetchManagersData();
        this.fetchCreatorsData();
        this.fetchReportData();
        this.scrollToBottom();

    },
    watch: {
        'projectViewData.comments': function (newComments) {
            if (newComments && newComments.length) {
                // Scroll to the end when comments are loaded or updated
                this.scrollToEnd();
            }
        },
        'projectViewData.comments'(newComments, oldComments) {
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        }
    },
    updated() {
        // Ensure the view scrolls to the bottom after every update
        if (this.activeTab === 'projectChat') {
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        }
    },
    computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission'
        }),
        userPermissionsTasks() {
            return this.getUserPermission('Tasks');
        },
        userPermissionsProjects() {
            return this.getUserPermission('Projects');
        },
        userPermissionsHours() {
            return this.getUserPermission('Hours');
        },
        userPermissionsClients() {
            return this.getUserPermission('Clients');
        },
        canEditProjectCreator() {
            return this.userPermissionsProjects?.editCreator === 1;
        },
        canEditTaskCreator() {
            return this.userPermissionsTasks?.editCreator === 1;
        },
        canCreate() {
            return this.userPermissionsTasks?.create === 1;
        },
        canViewAdminHours() {
            return this.userPermissionsHours?.viewAdmin === 1;
        },
        canUpdate() {
            return this.userPermissionsTasks?.create === 1;
        },
        canArchive() {
            return this.userPermissionsTasks?.archive === 1;
        },
        canCreateTask() {
            return this.userPermissionsTasks?.create === 1;
        },
        canArchiveTask() {
            return this.userPermissionsTasks?.archive === 1;
        },
        canEditAllProjects() {
            return this.userPermissionsProjects?.editAll === 1;
        },
        canEditAllTasks() {
            return this.userPermissionsTasks?.editAll === 1;
        },
        canViewAllClients() {
            return this.userPermissionsClients?.viewAdmin === 1;

        },
        superUser() {
            return this.getSuperUserPermission === 1;
        },
        getUser() {
            return this.$store.state.userInfo.id;
        },
        currentUser() {
            return localStorage.getItem('current_user_id'); // Safely retrieve the ID once
        }

    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const activeTab = ref(route.query.activeTab || 'info');
        const allData = ref({ users: [], clients: [], statuses: [], services: [] });
        const newComment = ref('');
        const toast = useToast();
        const currentUserInfo = ref(null);
        const projectViewData = ref(null);
        const selectedTaskIds = ref([]);
        const startDate = ref('');
        const endDate = ref('');
        const taskIdToArchive = ref(null);
        const filteredUsernames = ref([]);
        const showAutocomplete = ref(false);
        const users = ref([]);
        const managers = ref([]);
        const creators = ref([]);
        const isEditingGeneral = ref(false); // Ensure this is defined as a ref
        const reports = ref([]);
        const statusesReport = ref([]);
        const managerSelect = ref(null);
        const assignedUsersSelect = ref(null);
        const managerSelectTask = ref(null);
        const assignedUsersSelectTask = ref(null);
        const filtersReport = ref({
            dateFrom: '',
            dateTo: '',
            userId: [],
            statusId: []
        });
        const contentSearch = ref('');
        const contentSearchResults = ref([]);

        const fetchContent = async () => {
            

            const response = await searchContent({
                search: contentSearch.value,
                id: route.query.id,
                type: 'project'
            });

            if (response.data?.success) {

                const item = response.data.contentResults;
                
                contentSearchResults.value = [
                ...(item.projects),
                ...(item.tasks),
                ...(item.subtasks)
                ];
            }
        };



        // Watch for changes to startDate and endDate and update URL filters
        watch([startDate, endDate], ([newStartDate, newEndDate]) => {
            router.push({
                path: '/project',
                query: { ...route.query, startDate: newStartDate, endDate: newEndDate },
            });
        });
        watch(() => route.query.activeTab, (newVal) => {
            if (newVal) {
                activeTab.value = newVal
            }
        });
        const { data, paginationLinks, filters, updateFilters, fetchData, sortBy } = useFetchData(fetchAll, { id: route.query.id, page: route.query.page || 1, archived: route.query.archived }, { id: route.query.id, page: 1, archived: 0 });

        const transformDate = (dateStr) => {
            const [day, month, year] = dateStr.split('/');
            const formattedDate = `${year}-${month}-${day}`;
            return formattedDate;
        };
        const setActiveTab = (tab) => {
            activeTab.value = tab
            router.replace({ query: { ...route.query, activeTab: tab } })
        };

        const tinymceInit = {
            height: 500,
            license_key: 'gpl',
            ...editorSkin(),
            plugins: 'link autolink',
            toolbar: 'undo redo | bold italic underline | link',
        };

        const revertDate = (dateStr) => {
            const [year, month, day] = dateStr.split('-');
            const formattedDate = `${day}/${month}/${year}`;
            return formattedDate;
        };

        const openArchiveConfirmation = (taskId) => {
            taskIdToArchive.value = taskId;
            $('#archiveConfirmationModal').modal('show');
        };

        const confirmArchive = async () => {
            if (taskIdToArchive.value !== null) {
                const response = await massArchiveTasks({ ids: [taskIdToArchive.value] });
                if (response.data.success) {
                    fetchData();
                    useToast().success(response.data.message);
                } else {
                    useToast().error(response.data.message);
                }
                taskIdToArchive.value = null;
                $('#archiveConfirmationModal').modal('hide');
            }
        };

        const defaultProjectData = {
            title: '',
            description: '',
            manager_brief: '',
            clientId: '',
            assignedUsers: [],
            serviceId: '',
            managerId: '',
            statusId: 2,
            payable: '0',
            payManagerId: '',
            invoiced: '0',
            paid: '1',
            estimatedTime: '',
            startDate: '',
            endDate: ''
        };

        const projectData = ref(defaultProjectData);

        const defaultTaskData = {
            projectId: route.query.id || 0,
            title: '',
            body: '',
            manager_brief: '',
            assignedUsers: [],
            managerId: '',
            statusId: 2,
            totalHours: '',
            startDate: '',
            endDate: ''
        };

        const selectedManager = ref('');

        const isDropdownOpen = ref(false);

        const taskData = ref(defaultTaskData);

        const filteredAssignedUsersOptions = computed(() => {
            return allData.value.users.filter(user => user.id !== taskData.value.managerId);
        });

        // Αντικατάσταση των computed με ref
        const filteredAssignedUsers = ref([]);
        const filteredManagerOptions = ref([]);

        // Συνάρτηση που ενημερώνει τα φίλτρα
        const updateDropdowns = () => {
            // Ενημέρωση των filteredAssignedUsers και filteredManagerOptions
            filteredAssignedUsers.value = allData.value.users.filter(user => user.id !== projectData.value.managerId);
            filteredManagerOptions.value = allData.value.users.filter(user => !projectData.value.assignedUsers.includes(user.id));
        };


        // Watcher για το managerId
        watch(() => projectData.value.managerId, () => {
            // Όταν αλλάζει ο managerId, ενημερώνουμε τα φίλτρα
            updateDropdowns();
            // Αφαιρούμε τον manager από τους assignedUsers αν υπάρχει
            const index = projectData.value.assignedUsers.indexOf(projectData.value.managerId);
            if (index !== -1) {
                projectData.value.assignedUsers.splice(index, 1);
            }
            // Trigger για το Select2 να ανανεώσει τις επιλογές
            $('#taskManager').trigger('change');
            $('#assignedUsers').trigger('change');
        });

        // Watcher για τους assignedUsers
        watch(() => projectData.value.assignedUsers, () => {
            // Όταν αλλάζουν οι assignedUsers, ενημερώνουμε τα φίλτρα
            updateDropdowns();
            // Trigger για το Select2 να ανανεώσει τις επιλογές
            $('#taskManager').trigger('change');
            $('#assignedUsers').trigger('change');
        });



        const saveGeneral = async () => {
            console.log(projectData.value)
            const response = await updateGeneral(projectData.value);
            response.data.success ? toast.success(response.data.message) : toast.error(response.data.message);
            projectViewData.value = (await getProject({ id: route.query.id })).data.data;
            fetchData();
            isEditingGeneral.value = false;
        };

        const toggleDropdown = () => {
            isDropdownOpen.value = !isDropdownOpen.value;
        };

        const editProjectGeneral = async () => {
            try {
                const tmpAllData = await getClientsServicesStatusesUsers({ params: { type: "projects", entityId: route.query.id } });
                let newData = { users: [], statuses: [], clients: [], services: [] };

                for (let i = 0; i < tmpAllData.data.users.length; i++) {
                    newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
                }
                for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                    newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
                }
                for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                    newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
                }
                for (let i = 0; i < tmpAllData.data.services.length; i++) {
                    newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
                }

                allData.value = newData; // `allData` is a ref, so use `.value`

                const projectInfo = await getProject({ id: route.query.id });
                if (projectInfo.data.success) {
                    projectData.value = {
                        id: projectInfo.data.data.info.id,
                        projectId: route.query.id || 0,
                        createdBy: projectInfo.data.data.creator?.id,
                        description: projectInfo.data.data.info.description,
                        body: projectInfo.data.data.info.body,
                        manager_brief: projectInfo.data.data.info.manager_brief,
                        assignedUsers: projectInfo.data.data.assigned ? projectInfo.data.data.assigned?.map((assignedUser) => assignedUser.id) : [],
                        managerId: projectInfo.data.data.manager?.id,
                        serviceId: projectInfo.data.data.service?.id,
                        clientId: projectInfo.data.data.client?.id,
                        payable: projectInfo.data.data.info.payable || '0',
                        payManagerId: projectInfo.data.data.payManager?.id,
                        invoiced: projectInfo.data.data.info.invoiced || '0',
                        paid: projectInfo.data.data.info.paid || '0',
                        statusId: projectInfo.data.data.status?.id,
                        estimatedTime: projectInfo.data.data.info.estimatedTime,
                        startDate: transformDate(projectInfo.data.data.info.startDate),
                        endDate: transformDate(projectInfo.data.data.info.endDate)
                    };
                }

            } catch (error) {
                console.error('Error in editProjectGeneral:', error);
            }

            isEditingGeneral.value = true; // Use `.value` for reactive refs
        };

        const cancelEditingGeneral = async () => {
            isEditingGeneral.value = false;

        };

        const editTask = async (id) => {
            const tmpAllData = await getClientsServicesStatusesUsers({ params: { type: "project-tasks", entityId: route.query.id } });
            let newData = { users: [], statuses: [], clients: [], services: [] };
            for (let i = 0; i < tmpAllData.data.users.length; i++) {
                newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
            }
            for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
            }
            for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
            }
            for (let i = 0; i < tmpAllData.data.services.length; i++) {
                newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
            }
            allData.value = newData;
            const taskInfo = await getTask({ "id": id });
            if (taskInfo.data.success) {
                taskData.value = {
                    id: taskInfo.data.data.info.id,
                    projectId: route.query.id || 0,
                    createdBy: taskInfo.data.data.creator?.id,
                    title: taskInfo.data.data.info.title,
                    body: taskInfo.data.data.info.body,
                    manager_brief: taskInfo.data.data.info.manager_brief,
                    assignedUsers: taskInfo.data.data.assigned ? taskInfo.data.data.assigned?.map((assignedUser) => assignedUser.pivot.userId) : [],
                    managerId: taskInfo.data.data.manager?.id,
                    statusId: taskInfo.data.data.status?.id,
                    totalHours: taskInfo.data.data.info.totalHours,
                    startDate: taskInfo.data.data.info.startDate,
                    endDate: taskInfo.data.data.info.endDate
                };
            }
            $("#create-task-form").modal('toggle');
        };

        const archiveTask = async (taskId) => {
            const response = await massArchiveTasks({ ids: [taskId] });
            if (response.data.success) {
                fetchData();
                useToast().success(response.data.message);
            } else {
                useToast().error(response.data.message);
            }
        };

        const submitComment = async () => {
            const response = await createComment({ "id": route.query?.id, comment: newComment.value });
            if (response.data.success) {
                newComment.value = "";
                const projectDataTmp = await getProject({ id: route.query?.id || 0 });
                if (projectDataTmp.data.success) {
                    projectViewData.value = projectDataTmp.data.data;
                }
                $(".chat-history").animate({ scrollTop: $(".chat-history")[0].scrollHeight }, 1000);
                useToast().success(response.data.message);
            } else {
                useToast().error(response.data.message);
            }
        };

        // Update task status
        const updateTaskStatusId = async (task, statusId) => {
            const response = await updateTaskStatus(task.id, statusId);
            if (response.data.success) {
                fetchData();
                useToast().success(response.data.message);
            } else {
                useToast().error(response.data.message);
            }
            // Optionally, make an API call here to save the updated task status
        };

        const fetchReportData = () => {
            const { dateFrom, dateTo, userId, statusId } = filtersReport; // assuming using Vue 3 composition API or setup
            const projectId = route.query.id;

            console.log('Calling API with projectId:', projectId); // ✅ log this


            apiClient.get(`/get-report-project/${projectId}`, {
                params: {
                    date_from: dateFrom,
                    date_to: dateTo,
                    statusId: Array.isArray(statusId) ? statusId : [statusId],
                    userId: Array.isArray(userId) ? userId : [userId]
                }
            })
                .then((response) => {
                    if (response.data.success) {
                        // Store project statuses and tasks
                        reports.value = response.data.data.data.tasks.map(task => ({
                            ...task,
                            show: false // to toggle task details
                        }));
                        console.log(reports)
                        statusesReport.value = response.data.data.data.project_statuses;
                    }
                })
                .catch((error) => {
                    console.error('Error fetching data:', error);
                });
        };


        const updateManagerFilter = (managerId) => {
            // Now, managerId is passed directly from the selectManager method
            updateFilters({ ...filters.value, managerFilter: managerId, page: 1 });
        };

        const submitTaskForm = async () => {
            const response = await createOrUpdateTask(taskData.value);
            if (response.data.success) {
                fetchData();
                useToast().success(response.data.message);
                $("#create-task-form").modal('toggle');
            } else {
                useToast().error(response.data.message);
            }
        };

        const statuses = ref([]);
        const task_statuses = ref([]);



        const getStatusIcon = (id) => {
            const status = statuses.value.find(s => s.id === id);
            return status ? require(`@/assets/images/${status.img}`) : '';
            // const status = statuses.value.find((s) => s.id === id);
            // return status ? status.icon : "";
        };

        const getCurrentStatus = (id) => {
            const status = statuses.value.find((s) => s.id === id);
            return status ? status.description : "Select Status";
        };

        const toggleTaskSelection = (taskId, event) => {

        };

        const createTask = async () => {
            const tmpAllData = await getClientsServicesStatusesUsers({ params: { type: "project-tasks", entityId: route.query.id } });
            let newData = { users: [], statuses: [], clients: [], services: [] };
            for (let i = 0; i < tmpAllData.data.users.length; i++) {
                newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
            }
            for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
            }
            for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
            }
            for (let i = 0; i < tmpAllData.data.services.length; i++) {
                newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
            }
            allData.value = newData;
            taskData.value = {
                id: '',
                projectId: route.query.id || 0,
                title: '',
                manager_brief: '',
                body: '',
                assignedUsers: [],
                managerId: '',
                statusId: 2,
                totalHours: '',
                startDate: '',
                endDate: ''
            };
            $("#create-task-form").modal('toggle');
        };

        const getStatusStyle = (id) => statusStyle(id, 'min-width:9em; height:2.5em;');

        const submitForm = async () => {
            const response = await createOrUpdateProject(projectData.value);
            if (response.data.success) {
                const projectDataTmp = await getProject({ id: route.query.id || 0 });
                if (projectDataTmp.data.success) {
                    projectViewData.value = projectDataTmp.data.data;
                }
                fetchData();
                const projectInfo = await getProject({ "id": route.query.id || 0 });
                if (projectInfo.data.success) {
                    projectData.value = {
                        id: projectInfo.data.data.info.id,
                        projectId: route.query.id || 0,
                        description: projectInfo.data.data.info.description,
                        body: projectInfo.data.data.info.body,
                        manager_brief: projectInfo.data.data.info.manager_brief,
                        assignedUsers: projectInfo.data.data.assigned ? projectInfo.data.data.assigned?.map((assignedUser) => assignedUser.id) : [],
                        managerId: projectInfo.data.data.manager?.id,
                        serviceId: projectInfo.data.data.service?.id,
                        clientId: projectInfo.data.data.client?.id,
                        payable: projectInfo.data.data.info.payable || '0',
                        payManagerId: projectInfo.data.data.payManager?.id,
                        invoiced: projectInfo.data.data.invoiced || '0',
                        paid: projectInfo.data.data.paid || '0',
                        statusId: projectInfo.data.data.status?.id,
                        estimatedTime: projectInfo.data.data.info.estimatedTime,
                        startDate: transformDate(projectInfo.data.data.info.startDate),
                        endDate: transformDate(projectInfo.data.data.info.endDate)
                    };
                }
                useToast().success(response.data.message);
                $("#create-project-form").modal('toggle');
            } else {
                useToast().error(response.data.message);
            }
        };


        const selectStatus = async (projectId, statusId) => {
            const r = await updateProjectStatus(projectId, statusId);
            if (r.data.success) {
                useToast().success(r.data.message);
                const projectDataTmp = await getProject({ id: route.query.id || 0 });
                if (projectDataTmp.data.success) {
                    projectViewData.value = projectDataTmp.data.data;
                }
            } else {
                useToast().error(r.data.message);
            }
        };

        const searchAction = () => {
            setTimeout(() => {
                router.push({ path: '/project', query: { ...route.query, search: $("#main-search-input").val() } });
            }, 300);
        };

        const searchAction2 = () => {
            setTimeout(() => {
                router.push({ path: '/project', query: { ...route.query, search: $("#main-search-input2").val() } });
            }, 300);
        };

        const filteredUsersForManager = computed(() => {
            return allData.value.users?.filter(user =>
                !projectData.value.assignedUsers.includes(String(user.id))
            ) || [];
        });

        const filteredUsersForAssigned = computed(() => {
            return allData.value.users?.filter(user =>
                String(user.id) !== projectData.value.managerId
            ) || [];
        });

        watch(() => projectData.value.managerId, (newManagerId) => {
            if (projectData.value.assignedUsers.includes(newManagerId)) {
                projectData.value.assignedUsers = projectData.value.assignedUsers.filter(id => id !== newManagerId);
            }

            // Force re-render of assigned users select
            nextTick(() => {
                assignedUsersSelect.value?.$forceUpdate?.();
            });
        });

        watch(() => projectData.value.assignedUsers, (newAssigned) => {
            if (newAssigned.includes(projectData.value.managerId)) {
                projectData.value.managerId = '';
            }

            // Force re-render of manager select
            nextTick(() => {
                managerSelect.value?.$forceUpdate?.();
            });
        });

        const filteredUsersForManagerTask = computed(() => {
            return allData.value.users?.filter(user =>
                !taskData.value.assignedUsers.includes(String(user.id))
            ) || [];
        });

        const filteredUsersForAssignedTask = computed(() => {
            return allData.value.users?.filter(user =>
                String(user.id) !== taskData.value.managerId
            ) || [];
        });

        watch(() => taskData.value.managerId, (newManagerId) => {
            if (taskData.value.assignedUsers.includes(newManagerId)) {
                taskData.value.assignedUsers = taskData.value.assignedUsers.filter(id => id !== newManagerId);
            }

            // Force re-render of assigned users select
            nextTick(() => {
                assignedUsersSelectTask.value?.$forceUpdate?.();
            });
        });

        watch(() => taskData.value.assignedUsers, (newAssigned) => {
            if (newAssigned.includes(taskData.value.managerId)) {
                taskData.value.managerId = '';
            }

            // Force re-render of manager select
            nextTick(() => {
                managerSelectTask.value?.$forceUpdate?.();
            });
        });


        onMounted(async () => {
            fetchReportData();
            const tmpAllData = await getClientsServicesStatusesUsers({ params: { type: "projects", entityId: route.query.id } });
            let newData = { users: [], statuses: [], clients: [], services: [] };

            for (let i = 0; i < tmpAllData.data.users.length; i++) {
                newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
            }
            for (let i = 0; i < tmpAllData.data.statuses.length; i++) {
                newData.statuses.push({ id: tmpAllData.data.statuses[i].id, text: tmpAllData.data.statuses[i].description });
            }
            for (let i = 0; i < tmpAllData.data.clients.length; i++) {
                newData.clients.push({ id: tmpAllData.data.clients[i].id, text: tmpAllData.data.clients[i].title });
            }
            for (let i = 0; i < tmpAllData.data.services.length; i++) {
                newData.services.push({ id: tmpAllData.data.services[i].id, text: tmpAllData.data.services[i].title });
            }

            allData.value = newData; // `allData` is a ref, so use `.value`
            const allRequiredData = await getClientsServicesStatusesUsers({ params: { type: "projects", entityId: route.query.id } });
            const allRequiredDataTasks = await getClientsServicesStatusesUsers({ params: { type: "project-tasks", entityId: route.query.id } });

            statuses.value = allRequiredData.data.statuses;
            task_statuses.value = allRequiredDataTasks.data.statuses;
            users.value = allRequiredData.data.users;
            const userInfo = await fetchUserInfo();
            if (userInfo.data) {
                currentUserInfo.value = userInfo.data.info;
            }
            $(document.body).on('keyup', "#main-search-input", searchAction).on('click', "#main-search-input", searchAction);
            $(document.body).on('keyup', "#main-search-input2", searchAction2).on('click', "#main-search-input2", searchAction2);
            const projectDataTmp = await getProject({ id: route.query.id || 0 });
            if (projectDataTmp.data.success) {
                projectViewData.value = projectDataTmp.data.data;
            }
            document.addEventListener('click', handleClickOutside);

        });

        const getPageFromUrl = (url) => {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        };

        const selectUsername = (username) => {
            newComment.value = newComment.value.replace(/@(\w*)$/, `@${username} `);
            filteredUsernames.value = [];
            showAutocomplete.value = false;
        };
        const selectManager = (manager) => {
            selectedManager.value = manager.username;
            isDropdownOpen.value = false;  // Close the dropdown after selection
            updateManagerFilter(manager.id); // Call your update manager filter function
        };


        const dropdownTop = ref(0);
        const dropdownLeft = ref(0);
        const dropdownWidth = ref(0);

        const filterUsernames = () => {
            const input = newComment.value;
            const match = input.match(/@(\w*)$/); // Match @username pattern

            if (match) {
                const searchTerm = match[0].substring(1); // Extract text after '@'

                // Call the filtering logic only if there are at least 2 characters after "@"
                if (searchTerm.length >= 2) {

                    const query = match[1].toLowerCase();
                    filteredUsernames.value = users.value.filter(user =>
                        user.username.toLowerCase().includes(query)
                    );
                    showAutocomplete.value = filteredUsernames.value.length > 0;
                } else {
                    showAutocomplete.value = false;
                }
            } else {
                showAutocomplete.value = false;
            }
        };

        const handleClickOutside = (event) => {
            const dropdown = document.querySelector('.autocomplete-dropdown');
            const textarea = document.getElementById('commentTextarea');

            if (
                (dropdown && !dropdown.contains(event.target)) &&
                (!textarea || !textarea.contains(event.target))
            ) {
                showAutocomplete.value = false;
            }
        };



        onUnmounted(() => {
            $(document.body).off('keyup', "#main-search-input", searchAction).off('click', "#main-search-input", searchAction);
            $(document.body).off('keyup', "#main-search-input2", searchAction2).off('click', "#main-search-input2", searchAction2);
            document.removeEventListener('click', handleClickOutside);
        });

        return {
            currentUserInfo,
            users,
            showAutocomplete,
            selectUsername,
            filterUsernames,
            filteredUsernames,
            createTask,
            getPageFromUrl,
            paginationLinks,
            openArchiveConfirmation,
            confirmArchive,
            startDate,
            endDate,
            filters,
            updateFilters,
            archiveTask,
            editTask,
            submitForm,
            submitTaskForm,
            updateTaskStatusId,
            selectedTaskIds,
            sortBy,
            data,
            revertDate,
            setActiveTab,
            transformDate,
            searchAction,
            taskData,
            projectData,
            allData,
            projectViewData,
            route,
            activeTab,
            newComment,
            statuses,
            task_statuses,
            submitComment,
            getStatusIcon,
            getCurrentStatus,
            selectStatus,
            getStatusStyle,
            updateManagerFilter,
            editProjectGeneral,
            contentSearch,
            contentSearchResults,
            fetchContent,
            isEditingGeneral,
            cancelEditingGeneral, updateManagerFilter, selectManager, selectedManager, isDropdownOpen, toggleDropdown,
            saveGeneral, filteredAssignedUsersOptions, filteredAssignedUsers, filteredManagerOptions, updateDropdowns, tinymceInit, filteredUsersForManager, filteredUsersForAssigned, filteredUsersForManagerTask, filteredUsersForAssignedTask, toggleTaskSelection
        };
    }
};
</script>

<style scoped>
.chat-message {
    color: black !important;
}

.project-code {
    font-size: 1.5rem;
    font-weight: bold;
}

.status-dropdown {
    position: relative;
    display: inline-block;
}

.status-button {
    background-color: #f1f1f1;
    color: #333;
    padding: 8px 16px;
    font-size: 1rem;
    font-weight: bold;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    border-radius: 8px;

}

.status-button {
    background-color: transparent;
    color: #333;
    font-size: 1rem;
    font-weight: bold;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 3px;
    border-radius: 8px;

}

.status-dropdown:hover .status-dropdown-content {
    display: flex;
}

.status-dropdown:hover .status-dropdown-content-tasks {
    display: flex;
    flex-direction: row;
    right: 0;
}

.status-dropdown-content-tasks {
    z-index: 9000;
    position: absolute;
    background-color: white;
    min-width: fit-content;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    display: none;
    flex-direction: column;
}

.status-dropdown-content {
    z-index: 9000;
    position: absolute;
    background-color: white;
    min-width: fit-content;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.3);
    padding: 8px;
    border-radius: 8px;
    display: none;
    flex-direction: column;
    gap: 10px;
}

.status-dropdown>button {
    height: 1.5em;
}

.status-dropdown-content button {
    width: 100%;
    background: none;
    border: none;
    padding: 10px;
    text-align: left;
    font-size: 0.9rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
}

.status-dropdown-content-tasks button {
    width: 100%;
    background: none;
    border: none;
    padding: 10px;
    text-align: left;
    font-size: 0.8rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.status-dropdown-content-tasks button:hover {
    transform: scale(1.6);
    transition: .5s;
}

.status-dropdown-content button:hover {
    background-color: lightgray;
}

.active-status {
    font-weight: bold;
    background-color: #007bff;
    color: white;
    border-radius: 5px;
}

.create-task-button {
    width: 100%;
}


.nav-tabs {
    border: none;
}

/* Style for all list items to have a bottom border */
.nav-tabs .nav-item {
    border-bottom: 1px solid #DCDCDC;
    /* Light gray border for non-active items */
    /* margin-left:20px; */
}

.nav-tabs .nav-item .nav-link {
    color: #8C8C8C;
}

/* Style for the active tab to have a darker bottom border */
.nav-tabs .nav-item .nav-link.active,
.nav-tabs .nav-item .nav-link:hover {
    border-color: white;

    border-bottom: 3px solid #8C8C8C;
    /* Darker gray border for the active tab */
    color: black;

}

/* Optionally, you can remove the bottom border for non-active tabs on hover to make the UI clearer */

/* Add this CSS to ensure the button is placed on the right border */
.col-xl-8.col-lg-7.col-md-12 {
    position: relative;
    /* Make the parent div relative */
}

/* Style the button to be positioned absolutely at the border-right */
.status-button-wrapper {
    position: absolute;
    /* Position it absolutely within the parent */
    top: 50px;
    /* Vertically center the button */
    right: -25px;
    /* Position it slightly outside to touch the border-right */
    transform: translateY(-50%);
    /* Adjust for exact vertical centering */
    z-index: 10;
    /* Ensure the button stays above other elements */
}

.autocomplete-dropdown {
    position: absolute;
    z-index: 1000;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    max-height: 200px;
    /* Limit height */
    overflow-y: auto;
}

.autocomplete-dropdown ul {
    padding: 0;
    margin-top: 110px;
}

.autocomplete-item {
    padding: 8px 12px;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.autocomplete-item:hover {
    background-color: #f0f0f0;
    color: #333;
}

textarea {
    resize: none;
    overflow: auto;
}

textarea:focus {
    border-color: #007bff;
    outline: none;
    box-shadow: 0 0 4px rgba(0, 123, 255, 0.25);
}

/* .sendComment {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
} */

#commentTextarea {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}

.nav-tabs.tab-body-header .nav-link.active span {
    color: white;
}

#projectTableMobile {
    display: none !important;
}

.mobilefilters {
    display: none;
}

.dropdown-btn-filter {
    cursor: pointer;
    text-transform: capitalize;
    font-weight: 600;
    color: #545454;
}

.dropdown-btn {
    cursor: pointer;
}

/* Dropdown Options List */
.dropdown-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    border: 1px solid #dedede;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    z-index: 100;
    max-height: 200px;
    overflow-y: auto;
    width: 100%;
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 200px;
}

.dropdown-options-filters {
    position: absolute;
    border: 1px solid #dedede;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    z-index: 100;
    max-height: 200px;
    overflow-y: auto;
    width: fit-content;
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 200px;
}

.dropdown-options li,
.dropdown-options-filters li {
    padding: 10px 15px;
    cursor: pointer;
    font-size: 14px;
    color: #545454;
    font-weight: 600;
    border-bottom: 1px dashed lightgray;
}

.dropdown-options li:hover,
.dropdown-options-filters li:hover {
    background-color: #545454;
    color: white;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 90px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    width: 100%;
    /* Ensure the container is wide enough */
}

.dropdown-container:hover .dropdown-content {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: fit-content;
    padding: 8px 4px;
    border: 1px solid lightgray;
    z-index: 2;
    /* Stretch the dropdown to full width */
}

.dropdown-content button {
    display: block;
    /* Make buttons stack vertically */
    width: 100%;
    /* Make buttons take the full width of the container */
    margin: 0;
    /* Remove margin to avoid spacing issues */
    box-sizing: border-box;
    /* Ensure padding does not affect width */
    margin-bottom: 3px;
}


::v-deep(.select2-container--default .select2-selection--multiple) {
    border: 0px
}
::v-deep(.select2-container--default .select2-selection--single .select2-selection__rendered){
    border: 0px solid var(--border-color);
}
/* Fix Select2 in Modal for Mobile */
::v-deep .select2-container {
    width: 100% !important;
}

::v-deep .select2-dropdown {
    z-index: 9999 !important;
    /* Higher than modal z-index */
}

::v-deep .modal {
    z-index: 1050;
}

::v-deep .select2-container--open {
    z-index: 9999 !important;
}
@media screen and (max-width: 1279px) {
    .tagInfo {
        display: none !important;
    }

    .rightborderSec {
        border-right: 0px !important;
    }

    .status-button-wrapper {
        top: -10px;
        right: 15px;
        transform: translateY(-100%);
    }

    .editing-actions {
        flex-direction: row;
        align-items: baseline;
    }

    .justifyContentbetmob {
        justify-content: space-between;
    }

    .savebutton {
        width: 25px !important;
    }

    .cancelbutton {
        width: 25px !important;
    }

    .editbutton {
        width: 25px !important;
    }

    .tab-content {
        border-bottom: 1px solid lightgray;
    }

    .belowEditbtn {
        top: -35px !important;
    }

    .dateprojectdiv {
        display: flex;
        align-items: center;
    }

    .dateprojectdiv img {
        width: 20px !important;
    }

    .dateprojectdiv span {
        font-size: 13px !important;
    }

    .authorsChatDiv {
        width: 85% !important;
    }

    #commentTextarea {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    #projectTableMobile {
        display: flex !important;
    }

    .mobileRows {
        /* padding: 5px 10px; */
        border-bottom: 1px dashed #dedede;
        margin-bottom: 12px;
    }

    #myProjectTable {
        display: none;
    }

    .rightCol {
        padding-left: calc(var(--bs-gutter-x) * .5);
    }

    .mobilefilters {
        display: unset;
    }

    .desktopfilters {
        display: none;
    }
    .d-flex-mob{
        display: flex;
    }

    ::v-deep .select2-container--default .select2-selection--single {
        height: 38px;
        padding: 6px 12px;
    }

    ::v-deep .select2-container--default .select2-selection--multiple {
        min-height: 38px;
        padding: 3px;
    }

    ::v-deep .select2-dropdown {
        max-height: 200px;
        overflow-y: auto;
    }

    /* Ensure modal scrolls properly on mobile */
    .modal-dialog-scrollable .modal-body {
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
    
}
</style>
